import { Pipe, PipeTransform } from '@angular/core';
import { parseISO } from 'date-fns';

@Pipe({
  name: 'dfnsParseIso',
  pure: true,
})
export class DfnsParseIsoPipe implements PipeTransform {

  public transform(value: string | Date, options?: { additionalDigits?: 0 | 1 | 2 }): Date {
    return typeof value === 'string' ? parseISO(value, options) : new Date (value);
  }
}
